import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Button, CheckBox, InputField, TextArea, TitleLarge } from '../../components';
import { PLUS_ICON } from '../../utils/consts';

const ProjectCreatePage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Projekt erstellen</TitleLarge>
					<div className='container my-4'>
						<div className='row justify-content-center'>
							<form className='col-12 col-sm-8 col-xl-7'>
								<InputField
									id={'project_name'}
									classes={'background-secondary'}
									type={'text'}
									label={'Projektname'}
								/>
								<TextArea
									id={'project_desc'}
									label={'Beschreibung'}
									classes={'background-secondary'}
									style={{ minHeight: '150px', maxHeight: '400px' }}
								/>

								<InputField
									id={'project_url'}
									classes={'background-secondary'}
									type={'url'}
									label={'Projekt-URL'}
								/>
								<CheckBox id={'is_permanent'} label={'Permanent'} classes={'background-tertiary'} />
								<div className='d-flex justify-content-end mt-4'>
									<Button classes={'background-green px-4 py-2'} icon={PLUS_ICON}>
										Projekt erstellen
									</Button>
								</div>
							</form>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default ProjectCreatePage;
